// app/frontend/controllers/hello_controller.js

//Add this to your HTML:
//<div data-controller="hello">
//  Hi!
//</div>

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log("Hello, Stimulus!", this.element);
  }
}
